import { FC, ReactElement } from 'react'

import { ASSETS } from '../../../constants/paths'
import Image from './image'

type IconProps = {
  className: string
  icon: string
  alt: string
  size: { width: number; height: number }
}

const Icon: FC<IconProps> = ({ className, icon, alt, size }): ReactElement => {
  return <Image className={className} src={`${ASSETS}/icons/${icon}`} alt={alt} size={size} />
}

export default Icon
